import { render } from "./GeHome.vue?vue&type=template&id=60fdb6a2"
const script = {}

import "./GeHome.vue?vue&type=style&index=0&id=60fdb6a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__